<template>
  <div id="app">
    <Top :banners="banners" />
    <About :history="history" :mission="mission" />
    <CaseList :cases="cases" />
    <Records :records="records" />
    <Construction :sites="sites" :weekDates="weekDates" />
    <Renewal :laws="laws" :renewals="renewals" />
    <NewsList :newss="newss" />
    <Contact />
  </div>
</template>

<script>
import Top from './components/Top.vue'
import About from './components/About.vue'
import CaseList from './components/CaseList.vue'
import Records from './components/Records.vue'
import Construction from './components/Construction.vue'
import Renewal from './components/Renewal.vue'
import NewsList from './components/NewsList.vue'
import Contact from './components/Contact.vue'
import axios from 'axios'

export default {
  name: 'app',
  components: {
    Top,
    About,
    CaseList,
    Records,
    Construction,
    Renewal,
    NewsList,
    Contact,
  },
  data() {
    return {
      banners: [],
      history: '',
      mission: '',
      cases: [[], [], []],
      records: [],
      laws: [],
      renewals: [[], []],
      sites: [],
      weekDates: {},
      newss: [[], []],
    }
  },
  mounted() {
    axios.get('/api/all_data/')
    .then(({ data }) => {
      this.banners = data.banners;
      this.history = data.history;
      this.mission = data.mission;
      this.cases = data.cases;
      this.records = data.records;
      this.laws = data.laws;
      this.renewals = data.renewals;
      this.newss = data.newss;
      this.sites = data.sites;
      this.weekDates = data.week_dates;
    })
    .catch((err) => {
        alertify.alert('時詣建設', '很抱歉，目前網頁維修中，請您稍後再試！');
    })
  },
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
@media (min-width: 992px) {
  #app {
    margin-top: 56px;
  }
}
</style>
